
























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import { Toast,Dialog } from "vant";
import { TbOrderPad, TbPickupOrder, TbReturnOrder, TbSettingsPad, TbShopAccount } from "@/http";
import calculate from "@/common/util/calculate";
import { fmoney } from "@/common/util/money";
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 ||userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
@Component({
  components: {},
})
export default class deliveryDetail extends Vue {
  public $refs: {};

  show = false;

  form: any = {};
  type = 1;

  fmoney = fmoney;

  loading = false;
  changesyy = false;
  cashierlist = [];
  curselid = "";
  curselname = "";

  userInfo = {};
  baseInfo:any = {};

  totalCount = 0;
  totalPrice = 0;


  created() {
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
  }
  mounted() {
   
  }

  async init(id) {
    this.loading = true;
    try {
        let res = await TbPickupOrder.GetTbPickupOrderItemList({
          id: id,
        });
        this.form = res;
        this.totalCount = res.totalCount;
        this.totalPrice = res.totalPrice;
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  async showFun(item) {
    this.baseInfo = item;
    await this.init(item.id);
    this.show = true;
  }

  closeFun() {
    this.resetFun();
    this.show = false;
  }

  resetFun() {
    this.form = {};
    this.baseInfo = {};
  }

  
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/components/deliveryDetail.vue